import { Box } from '@mui/material';
import _ from 'lodash';
import React from 'react';
import { useGetOrganizationIntegrations } from '../../../services/react-query/integrations/useGetOrganizationIntegrations';
import { CalendarPartner, Integration } from '../../../types/Integration';
import { UserSettingsCollapseKeys } from '../../../types/User';
import GoogleEventTemplateIntegration from './GoogleEventTemplateIntegration';
import OutlookEventTemplateIntegration from './OutLookEventTemplateIntegration';
import AccordionSection from '../../AccordionSection';

interface Props {
  integrations: Integration[];
  setIntegrations: (integrations: Integration[]) => void;
}

// Mapping of partners to their components
const partnerComponentMap = {
  [CalendarPartner.GOOGLE]: GoogleEventTemplateIntegration,
  [CalendarPartner.OUTLOOK]: OutlookEventTemplateIntegration,
};

export default function IntegrationSection({ integrations, setIntegrations }: Props) {
  const { data: integrationResponse } = useGetOrganizationIntegrations({});

  const availablePartners = _.filter(Object.values(CalendarPartner), (partner) => _.some(integrationResponse?.data, { partner }));

  return (
    <AccordionSection collapseId={UserSettingsCollapseKeys.EVENT_TEMPLATE_INTEGRATIONS} title="Integrations">
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, width: '100%' }}>
        {_.map(availablePartners, (partner) => {
          const IntegrationComponent = partnerComponentMap[partner];
          if (!IntegrationComponent) return null;

          const integration = _.find(integrations, { partner }) || null;

          return (
            <IntegrationComponent
              key={partner}
              integration={integration}
              setIntegration={(updated) => {
                const updatedList = _.filter(integrations, (i) => i.partner !== partner);
                if (updated) updatedList.push(updated);
                setIntegrations(updatedList);
              }}
            />
          );
        })}
      </Box>
    </AccordionSection>
  );
}
